import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'timeFormatPipe',
    standalone: false
})
export class TimeFormatPipe implements PipeTransform {
    
    transform(value: any, arg1:string = null) {
        const valueOutput = this.formatMiliseconds(+value, arg1)
        return valueOutput;
    }

    formatMiliseconds(ms:any, arg1:string) {

        if(ms == 0){
            return `${ms} milisegundos`
        }

        let days = 0;
        let hours = 0;
        let minutes = 0;
        let seconds = 0;

        switch (arg1) {
            case 'hours':
                hours = Math.floor(ms / 3600000); // 3600 segundos en una hora
                ms %= 3600000;
                minutes = Math.floor(ms / 60000);
                ms %= 60000;
                seconds = Math.floor(ms / 1000);
                ms %= 1000;
                break;
        
            default:
                days = Math.floor(ms / 86400000); // 86400 segundos en un día
                ms %= 86400000;
                hours = Math.floor(ms / 3600000); // 3600 segundos en una hora
                ms %= 3600000;
                minutes = Math.floor(ms / 60000);
                ms %= 60000;
                seconds = Math.floor(ms / 1000);
                ms %= 1000;
                break;
        }

        if(days > 0){
            return `${days} d ${hours} hr ${minutes} min`;
        }else{
            if(hours > 0){
                return `${hours} hr ${minutes} min`;
            }else{
                if(minutes>0){
                    return `${minutes} min`;
                }else{
                    if(seconds>0){
                        return `${seconds} seg`;
                    }else{
                        return `${ms} ms`;
                    }
                    
                }
                
            }
        }

    
    };
}